import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import AppContent from "./AppContent";
import Loader from "./components/Loader";

function App() {
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    const handlePageLoad = () => {
      setPageLoading(false);
    };

    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
      return () => window.removeEventListener("load", handlePageLoad);
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      {pageLoading ? <Loader /> : <AppContent />}
    </Router>
  );
}

export default App;
